/**
 * Token tema per assi/griglia/tooltip/legenda dei chart Recharts.
 *
 * Estratti da `EffortLoadChart.tsx` (leopart-update/components/effort/charts):
 * è l'unico chart del repo con i token corretti su ogni elemento. I chart di
 * `TrainingStatisticsDashboard` usano invece hex fissi (`#00212c`, `#5a5a5a`,
 * `#063444`) illeggibili in dark mode — da qui in poi i nuovi chart li
 * importano da questo file invece di reintrodurli.
 */
export const CHART_FONT_FAMILY = "'Satoshi', sans-serif";

/** Prop `tick` di XAxis/YAxis. */
export const chartAxisTick = {
  fill: 'var(--c-text-1)',
  fontSize: 11,
  fontFamily: CHART_FONT_FAMILY,
};

/** Prop sparse su `<CartesianGrid />`. */
export const chartGridProps = {
  strokeDasharray: '3 3',
  stroke: 'var(--c-divider)',
  vertical: false,
};

/** Prop `contentStyle` di `<Tooltip />`. */
export const chartTooltipContentStyle = {
  background: 'var(--c-card-bg)',
  border: '1px solid var(--c-card-border)',
  borderRadius: 8,
};

/** Prop `labelStyle` di `<Tooltip />`. */
export const chartTooltipLabelStyle = { color: 'var(--c-text-1)' };

/** Prop `itemStyle` di `<Tooltip />`. */
export const chartTooltipItemStyle = { color: 'var(--c-text-0)' };

/** Prop `wrapperStyle` di `<Legend />`. */
export const chartLegendStyle = {
  fontSize: 11,
  fontFamily: CHART_FONT_FAMILY,
};

/** Stile della label-dato disegnata sopra/accanto a una barra (il numero, non la categoria). */
export const chartDataLabelStyle = {
  fill: 'var(--c-text-0)',
  fontSize: 11,
  fontFamily: CHART_FONT_FAMILY,
};
